import React, { useState, useEffect } from "react";
import CssTransition from "../../../component/layout/css-transition";
import { useDispatch, useSelector } from "react-redux";
import {
  getMasterToDosList,
  importMasterToDo,
} from "../../../redux/actions/todo";
import swal from "@sweetalert/with-react";
import CustomeModal from "../../../component/modal-popup/customeModal";
import Table from "../../../component/table";
import SearchForm from "../../../component/search-form";
import { sanitizeInput } from "../../../utils";

function DownloadComponentModal({
  modalOpen,
  setModalOpen,
  setUpdateTable,
  updateTable,
}) {
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [loader, setLoader] = useState(false);
  const [selected, setSelected] = useState([]);
  const [sort, setSort] = useState();
  const [masterTodoList, setMasterTodoList] = useState([]);
  const [searchText, setSearchText] = useState("");

  const dispatch = useDispatch();
  const { defaultMasterToDos } = useSelector((state) => state.todo);

  // Function to call API to get master To Dos
  const getDefaultToDoList = () => {
    setLoader(true);
    const request = {
      onSuccess: () => {
        setLoader(false);
      },
      onError: () => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content="Unable to fetch To Do list"
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(getMasterToDosList(request));
  };

  useEffect(() => {
    if (modalOpen) {
      getDefaultToDoList();
    }
  }, [modalOpen]);

  useEffect(() => {
    return () => {
      setSort();
    }
  }, [modalOpen])

  useEffect(() => {
    setMasterTodoList(defaultMasterToDos)
  }, [defaultMasterToDos]);


  useEffect(() => {
    if(sort){
      const sortArray = [...masterTodoList];

      sortArray.sort((a, b) => {
        if (sort.type === "asc" && a[sort.headName] < b[sort.headName]) {
          return -1;
        } else if (
          sort.type === "asc" &&
          a[sort.headName] > b[sort.headName]
        ) {
          return 1;
        } else if (
          sort.type === "desc" &&
          a[sort.headName] > b[sort.headName]
        ) {
          return -1; // Return a negative value for descending sort
        } else if (
          sort.type === "desc" &&
          a[sort.headName] < b[sort.headName]
        ) {
          return 1; // Return a positive value for descending sort
        } else {
          return 0;
        }
      });

      setMasterTodoList(sortArray);
    }

  }, [sort])

  useEffect(() => {
    
    setMasterTodoList((prev) => {
      return searchText !== "" ? prev.filter(item => item.name.toLowerCase().includes(searchText.toLowerCase())) : [...defaultMasterToDos];
    })

    if(searchText === "" && sort){

      const sortArray = [...defaultMasterToDos];
  
        sortArray.sort((a, b) => {
          if (sort.type === "asc" && a[sort.headName] < b[sort.headName]) {
            return -1;
          } else if (
            sort.type === "asc" &&
            a[sort.headName] > b[sort.headName]
          ) {
            return 1;
          } else if (
            sort.type === "desc" &&
            a[sort.headName] > b[sort.headName]
          ) {
            return -1; // Return a negative value for descending sort
          } else if (
            sort.type === "desc" &&
            a[sort.headName] < b[sort.headName]
          ) {
            return 1; // Return a positive value for descending sort
          } else {
            return 0;
          }
        });
  
        setMasterTodoList(sortArray);
    }

  }, [searchText])

  const downloadToDo = () => {
    if (selected.length === 0) {
      return swal({
        content: (
          <CustomeModal
            type="error"
            title="Error!"
            content="Please select To Do to download."
          />
        ),
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
      });
    }

    setDownloadLoader(true);
    const request = {
      onSuccess: () => {
        setModalOpen(!modalOpen);
        setDownloadLoader(false);
        setSelected([]);
        setUpdateTable(updateTable + 1);
      },
      onError: (error) => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content= {error.message ? error.message : "Unable to download To Do. Please try again later."}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
        setDownloadLoader(false);
      },
      payload: {
        master_activity_ids: selected,
      },
    };
    dispatch(importMasterToDo(request));
  };


  const handleSelection = (todo_id) => {
    setSelected((prev) => {
      return prev.includes(todo_id) ? prev.filter(item => item !== todo_id) : [...prev, todo_id]
    })
  }

  return (
    <>
      <CssTransition
        className="fixed inset-0 bg-slate-900 bg-opacity-30 z-50 transition-opacity"
        show={modalOpen}
        enter="transition ease-out duration-200"
        enterStart="opacity-0"
        enterEnd="opacity-100"
        leave="transition ease-out duration-100"
        leaveStart="opacity-100"
        leaveEnd="opacity-0"
        aria-hidden="true"
      />
      <CssTransition
        className="fixed inset-0 z-50 overflow-hidden flex items-center my-4 justify-center px-4 sm:px-6"
        role="dialog"
        aria-modal="true"
        show={modalOpen}
        enter="transition ease-in-out duration-200"
        enterStart="opacity-0 translate-y-4"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-in-out duration-200"
        leaveStart="opacity-100 translate-y-0"
        leaveEnd="opacity-0 translate-y-4"
      >
        <div className="bg-white overflow-auto max-w-4xl h-[750px] w-full rounded-2xl shadow-lg flex flex-col relative">
          <div className="py-8 px-6 space-y-5">
            <div className="space-y-2">
              <h4 className="text-base leading-5 text-[#1E293B] font-semibold text-center">
                Download Existing To Dos
              </h4>
              <div>
                <p className="text-sm text-center text-[#888888] leading-5">
                  Please select the To Dos you want to download.
                </p>
              </div>
            </div>

            {/* Search Functionality */}

            <div className="grid grid-cols-1 gap-4 px-6 py-4 bg-[--bg-color-50] rounded">
              <div className="space-x-4 flex items-center">
                <h4 className="text-xl leading-5 font-bold tracking-tight">
                  Master To Do List
                </h4>
                <SearchForm
                  placeholder="Search"
                  onChange={(e) => {
                    const value = sanitizeInput(e.target.value);
                    setSearchText(value);
                  }}
                  value={searchText}
                />
              </div>
            </div>

            <div className="w-full max-h-[450px]">
              <div className="max-h-[450px] max-w-full overflow-y-auto scrollbar scrollbar-w-2 scrollbar-thumb-rounded-full scrollbar-track-rounded-full scrollbar-thumb-gray-300 scrollbar-track-gray-100">
                <Table
                  heads={[
                    {
                      headName: "To Do Name",
                      isSort: true,
                      value: "name",
                    },
                    {
                      headName: "Description",
                      isSort: false,
                      value: "description",
                    },
                    {
                      headName: "Based On",
                      isSort: false,
                      value: "based_on",
                    },
                    {
                      headName: "Badge",
                      isSort: false,
                      value: "badge",
                    },
                  ]}
                  tClass="table-fixed w-full border-separate border-spacing-y-2"
                  hClass="text-[14px] leading-2 text-[#1E293B] !bg-[--bg-color-50] tracking-wide sticky top-0 text-left font-semibold"
                  bClass="text-[14px] !text-left"
                  thClass={`h-[40px] whitespace-nowrap text-left font-semibold first:rounded-l last:rounded-r max-w-10 sticky top-0 first:pl-4`}
                  setSort={setSort}
                  sort={sort}
                >
                  {loader ? (
                    <tr className="whitespace-nowrap h-[40px] text-center cursor-pointer">
                      <td colSpan={4}>
                        <div className="w-full flex justify-center items-center">
                          <span className="ml-2">
                            <svg
                              className="animate-spin w-5 h-45 fill-current shrink-0"
                              viewBox="0 0 16 16"
                            >
                              <path d="M8 16a7.928 7.928 0 01-3.428-.77l.857-1.807A6.006 6.006 0 0014 8c0-3.309-2.691-6-6-6a6.006 6.006 0 00-5.422 8.572l-1.806.859A7.929 7.929 0 010 8c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z" />
                            </svg>
                          </span>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    masterTodoList.map((item, index) => {
                      return (
                        <tr
                          key={item.name + index}
                          className={`whitespace-nowrap ${
                            selected.includes(item.id)
                              ? "bg-[--bg-color-500]"
                              : "bg-[--bg-color-50]"
                          }  h-[40px] text-center cursor-pointer`}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSelection(item.id);
                          }}
                          // onClick={() => {
                          //   if (selected[0] === item.id) {
                          //     setSelected([]);
                          //   } else {
                          //     setSelected([item.id]);
                          //   }
                          // }}
                        >
                          <td
                            title={item.name}
                            className={`text-left pl-4 rounded-tl rounded-bl max-w-full truncate font-semibold ${
                              selected.includes(item.id) && "text-white"
                            }`}
                          >
                            {item.name}
                          </td>
                          <td
                            title={item.description}
                            className={`text-left max-w-[98%] truncate ${
                              selected.includes(item.id) && "text-white"
                            }`}
                          >
                            {item.description}
                          </td>
                          <td
                            title={item.based_on}
                            className={`text-left max-w-full truncate ${
                              selected.includes(item.id) && "text-white"
                            }`}
                          >
                            {item.based_on}
                          </td>

                          <td
                            className={`text-left rounded-tr rounded-br ${
                              selected.includes(item.id) && "text-white"
                            }`}
                          >
                            {item.is_immutable
                              ? "Tracking"
                              : "Default Shiperone To Do"}
                          </td>
                        </tr>
                      );
                    })
                  )}
                </Table>
              </div>
            </div>

            {/* ----- Footer ---- */}
            <div className="flex justify-center items-center">
              <div className="w-1/2 flex justify-between items-center space-x-4">
                <div className="w-1/2">
                  <button
                    className="w-full btn bg-white border border-slate-200 hover:border-slate-300 text-[#1E293B]"
                    onClick={() => {
                      setModalOpen(!modalOpen);
                      setSelected([]);
                    }}
                  >
                    Cancel
                  </button>
                </div>
                <div className="w-1/2">
                  <button
                    className={`w-full btn  text-white ${
                      downloadLoader ? "bg-[--bg-color-300]" : "bg-[--bg-color-500]"
                    }`}
                    onClick={() => downloadToDo()}
                  >
                    {downloadLoader ? (
                      <>
                        <span class="fa-solid fa-download fa-bounce text-white text-base mr-2"></span>
                        Downloading...
                      </>
                    ) : (
                      "Download"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </CssTransition>
    </>
  );
}

export default DownloadComponentModal;
